export default {
  doctorInformation: state => state.doctorInformation,
  loadedDoctorInformation: state => state.loadedDoctorInformation,
  doctorMedicalLicenceStatus: state => state.doctorMedicalLicenceStatus,
  profile: state => state.profile,
  providerError: state => state.error,
  doctorProfileLoading: state => state.getDoctorProfileLoading,
  providerEmailValidation: state => state.providerEmailValidation,
  originalProfile: state => state.originalProfile,
  modifyProfile: state => state.modifyProfile,
  providerStatus: state => state.providerStatus
}